/* unplugin-vue-components disabled */import script from "./menu.vue?vue&type=script&setup=true&lang=js"
export * from "./menu.vue?vue&type=script&setup=true&lang=js"

import "./menu.vue?vue&type=style&index=0&id=5930b4e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5930b4e0"]])

export default __exports__